import { useContext, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../../shared/routing/appPaths";
import { ThreadContext } from "../page/threadPageContext";

/**
 * A reference to an earlier entry of this Run, in words ("Eintrag 12", or the phrase given), never a bare "#12": a link
 * up the page to it (P2-3; Johannes, 4 Nov 16:32). Outside a Run view, the words alone.
 */
export default function EntryLink({ entry, children }: { entry: number; children?: ReactNode }) {
  const { t } = useTranslation();
  const threadId = useContext(ThreadContext)?.threadId;
  const words = children ?? t("threads.log.entry", { entry });
  if (threadId === undefined) return <>{words}</>;
  return (
    <Link to={appPaths.thread(threadId, entry)} className="app-link app-link-cue-up">
      {words}
    </Link>
  );
}
